import AnchorLinkListBlock from 'components/anchor-link-list-block';
import mainContentDefaultOptions from './main-content-default-options';

// NOTE: Default options for 'ComponentList' when rendered in a sidebar or other small layout.
export default {
  ...mainContentDefaultOptions,
  additionalComponentProps: {
    ...mainContentDefaultOptions.additionalComponentProps,
    AnchorLinkListBlock: { theme: AnchorLinkListBlock.themes.narrow }
  }
};
